import { NOT_FOUND } from 'redux-first-router';

export const notFound = () => ({
  type: NOT_FOUND
});

export const loading = payload => ({
  type: 'GLOBAL_LOADING',
  payload
});
